<div class="app" dir="ltr">
  <!-- TODOEVENTUALLY MMD - connecting...?? -->
  <!--  <div class="connecting" *ngIf="!backend.connected">-->
  <!--    <div class="connecting-text">CONNECTING</div>-->
  <!--    <div class="connecting-info">If this problem persists, please reload the page.</div>-->
  <!--  </div> -->
  <swipesum-header appName="audit">
    @if (auth.isAuthenticated() && user && (isAdminUser || isSetupComplete) && !isInAccountSetup()) {
    <div primary-navigation style="width: 100%;">
      <div style="display: flex; width: 100%; align-items: center; height: 50px;">
        <div class="main-header__nav">
          <div id="primary-nav" style="display: flex; align-items: center; gap: 10px;">
            <div style="padding: 0 15px;">
              <a routerLink="/manage/merchants" [class.selected]="isActive('merchants')">Merchants</a>
            </div>
            @if (isAdminUser) {
            <div style="padding: 0 15px;">
              <a routerLink="/manage/admin/statement-reviews" [class.selected]="isActive('review')">Review</a>
            </div>
            }
            @if ((isOrgAdminUser || isOrgBillingAdminUser) && !isAdminUser) {
            <div style="padding: 0 15px;">
              <a [routerLink]="primaryBillingLink()" [class.selected]="isBillingNavActive()">Billing</a>
            </div>
            }
            @if (isAdminUser || isOrgAdminUser || isOrgBillingAdminUser || isTeamLead() || isGroupAdminUser) {
            <div class="main-header__nav-item">
              <button type="button" class="primary-nav-manage" [class.selected]="isActiveManage()"
                (click)="manageMenuOpen = !manageMenuOpen">
                Manage
                <span class="material-symbols-outlined" style="font-size: 18px;">arrow_drop_down</span>
              </button>
              @if (manageMenuOpen) {
              <div class="profile-dropdown__menu">
                @if (isAdminUser) {
                <button class="profile-dropdown__item" (click)="manageMenuOpen = false"
                  routerLink="/manage/impersonate">
                  impersonate
                </button>
                }
                <button class="profile-dropdown__item" (click)="manageMenuOpen = false" routerLink="/manage/statements">
                  statements
                </button>
                @if ((isAdminUser && isImpersonating) || !isAdminUser) {
                <button class="profile-dropdown__item" (click)="manageMenuOpen = false" routerLink="/manage/proposals">
                  proposals
                </button>
                }
                @if (isAdminUser) {
                <button class="profile-dropdown__item" (click)="manageMenuOpen = false"
                  routerLink="/manage/admin/registration-approval">
                  registration
                </button>
                <button class="profile-dropdown__item" (click)="manageMenuOpen = false"
                  routerLink="/manage/admin/users">
                  users
                </button>
                <button class="profile-dropdown__item" (click)="manageMenuOpen = false"
                  routerLink="/manage/admin/client-management">
                  clients
                </button>
                <button class="profile-dropdown__item" (click)="manageMenuOpen = false"
                  routerLink="/manage/admin/billing-management">
                  billing
                </button>
                }
                @if (((isOrgAdminUser || isGroupAdminUser) && !isTrialPlanOrg() && !isAdminUser) || (isAdminUser &&
                isImpersonating && !isTrialPlanOrg())) {
                <button class="profile-dropdown__item" (click)="manageMenuOpen = false"
                  routerLink="/manage/organization-settings/organization-management">
                  {{isAdminUser ? 'organization-management': isGroupAdminUser ? 'group': 'organizations'}}
                </button>
                <button class="profile-dropdown__item" (click)="manageMenuOpen = false"
                  routerLink="/manage/organization-settings/organization-users">
                  {{isAdminUser ? 'organization-users': 'users'}}
                </button>
                @if (isAdminUser && isImpersonating && !isTrialPlanOrg()) {
                  <button class="profile-dropdown__item" (click)="manageMenuOpen = false"
                    [routerLink]="primaryBillingLink()">
                    organization-billing
                  </button>
                }
                <!-- documentation moved to new page -->
                <!-- <button class="profile-dropdown__item" (click)="manageMenuOpen = false"
                  routerLink="/manage/organization-settings/organization-advanced">
                  {{isAdminUser ? 'organization-advanced': 'advanced'}}
                </button> -->
                }
              </div>
              }
            </div>
            }
          </div>
        </div>
        <div style="flex: 1"></div>
        @if (isSetupComplete && !isInvoicePlanOrg() && !isOrgDisabled && !isClosedTrial()) {
        <span class="app-header-credits">{{organization?.remainingCreditCount}} CREDITS</span>
        }
        <div style="display: flex; padding-right: 24px; align-items: center;">
          <div class="help-dropdown" style="position: relative;">
            <button type="button" class="profile-btn" (click)="helpMenuOpen = !helpMenuOpen">help</button>
          </div>
          <div class="profile-dropdown">
            <button type="button" class="profile-btn" (click)="profileMenuOpen = !profileMenuOpen">
              profile
              <span class="material-symbols-outlined">arrow_drop_down</span>
            </button>
            @if (profileMenuOpen) {
            <div class="profile-dropdown__menu">
              <div class="profile-dropdown__email">{{user?.email}}</div>
              <button class="profile-dropdown__item" (click)="auth.logout(); profileMenuOpen = false">
                sign out
              </button>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
    }
  </swipesum-header>

  @if (helpMenuOpen) {
  <div class="help-banner">
    <span class="help-banner__close" (click)="helpMenuOpen = false">
      <span class="material-symbols-outlined">close</span>
    </span>
    <span class="material-symbols-outlined help-icon">help</span>
    <div class="help-banner__item">
      <span class="help-banner__label">Call our support team</span>
      <a class="help-banner__link" href="tel:18448775753">1-844-877-5753</a>
    </div>
    <div class="help-banner__item">
      <span class="help-banner__label">Send us a message</span>
      <a class="help-banner__link" href="mailto:support@swipesum.com">support@swipesum.com</a>
    </div>
    <!-- TODO ADD THIS BACK WHEN WE HAVE A SUPPORT CENTER -->
    <!-- <div class="help-banner__item">
      <span class="help-banner__label">Browse our how-to index</span>
      <a class="help-banner__link" href="#">launch support center TODO</a>
    </div> -->
  </div>
  }
  <mat-sidenav-container class="app-inner">
    <mat-sidenav #end align="end" class="chat-panel" mode="over" opened="false" position="end">
      <div class="scroll">
        <mat-list class="pt-1 pb-1">
          <mat-list-item>
            <div fxLayout="column">
              <h2 class="ma-0">{{ today | date:'EEEE' }}</h2>
              <h3 class="mat-text-muted ma-0">
                <span>{{ today | date:'dd' }}</span>&nbsp;<span>{{ today | date:'MMMM' }}</span>
              </h3>
            </div>
          </mat-list-item>
        </mat-list>
        <div class="chat-panel-rows">
          <mat-divider></mat-divider>
          <h3 matSubheader class="text-uppercase font-weight-bold h3-headers">Credit Info</h3>
          <div class="chat-panel-row">
            <div class="chat-panel-row-label">Credits Used</div>
            <span class="chat-panel-row-value">{{organization?.creditUsageCount}}</span>
          </div>
          @if (!isInvoicePlanOrg()) {
          <div class="chat-panel-row">
            <div class="chat-panel-row-label">Remaining Credits</div>
            <span class="chat-panel-row-value">{{organization?.remainingCreditCount}}</span>
          </div>
          }
          @if (organization?.lastBilledDate) {
          <div class="chat-panel-row">
            <div class="chat-panel-row-label">Last Billing Cycle Date</div>
            <span class="chat-panel-row-value">{{organization?.lastBilledDate | date: 'yyyy-MM-dd'}}</span>
          </div>
          }
          @if (organization?.nextBillDate) {
          <div class="chat-panel-row">
            <div class="chat-panel-row-label">Next Billing Cycle Date</div>
            <span class="chat-panel-row-value">{{organization?.nextBillDate}}</span>
          </div>
          }
          @if (isTrialPlanOrg() && organization) {
          <div class="chat-panel-row" [ngClass]="{'low-credits': organization.remainingDays < 3}">
            <div class="chat-panel-row-label">Remaining Days in Trial</div>
            <span class="chat-panel-row-value">{{organization?.remainingDays}}</span>
          </div>
          }

          <mat-divider></mat-divider>
          <h3 matSubheader class="text-uppercase font-weight-bold h3-headers">Current Plan Information</h3>
          @if (!isTrialPlanOrg()) {
          <div class="chat-panel-row">
            <div class="chat-panel-row-label">{{organization?.paymentPlan?.name}} Plan</div>
            @if (isCreditPlanOrg()) {
            <span class="h4 chat-panel-row-value">{{organization?.paymentPlan?.creditsPerMonth}} <small
                class="text-sm">credits per month</small></span>
            }
            @if (isInvoicePlanOrg()) {
            <span class="h4 chat-panel-row-value">{{organization?.paymentPlan?.amountPerCredit | currency}} <small
                class="text-sm">per credit</small></span>
            }
          </div>
          }
          @if (isTrialPlanOrg()) {
          <div class="chat-panel-row">
            <span class="h4 chat-panel-row-value"><small class="text-sm">Free Trial</small></span>
          </div>
          }
          <mat-divider></mat-divider>
        </div>
        @if (isCreditPlanOrg() && isOrgAdminUser && isSetupComplete) {
        <button mat-raised-button color="primary" class="ma-2" (click)="end.close()"
          routerLink="/manage/organization-settings/organization-billing">
          Buy More Credits
        </button>
        }
        @if (isTrialPlanOrg() && isSetupComplete && !isAdminUser) {
        <button mat-raised-button class="ma-2 secondary-button" (click)="end.close()"
          routerLink="/manage/upgrade-account">
          Upgrade Account
        </button>
        }
      </div>
    </mat-sidenav>

    @if (isCreditAccountAlertVisible()) {
    <div id="credit-alert" class="py-xs">
      <credit-account-alert [isOrgAdminUser]="isOrgAdminUser"></credit-account-alert>
    </div>
    }
    @if (isSubscriptionAccountAlertVisible()) {
    <div id="subscription-alert" class="py-xs">
      <subscription-account-alert [isOrgBillingAdminUser]="isOrgBillingAdminUser"
        [subscriptionStatus]="organization?.subscription?.status"></subscription-account-alert>
    </div>
    }
    @if (isTrialAccountAlertVisible()) {
    <div id="trial-alert" class="py-xs">
      <trial-account-alert [remainingCreditCount]="organization.remainingCreditCount"
        [remainingDays]="organization.remainingDays" [showUpgradeButton]="!isAdminUser"></trial-account-alert>
    </div>
    }
    <router-outlet></router-outlet>

    <swipesum-footer appName="audit" class="footer-container"></swipesum-footer>
  </mat-sidenav-container>

</div>